import { 
  Grid, 
  Button, 
  TextField, 
  Typography, 
  Autocomplete,
  Switch,
  FormControlLabel
} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { Form as FormikForm, useFormikContext } from "formik";
import { departmentSiglas } from "../../../../utils/lists";
import Iconify from '../../../iconify';

export const CreateOrganizationForm = ({ onClose }) => {
    const { isSubmitting, values, setFieldValue } = useFormikContext();

    const roles = [
        "Administrador", "Soporte", "Administrador Tickets", "Usuario", "Imprimir Cheques", "Personalities", 
        "Personalities Admin", "InventoryAdmin", "Enrollment", "Communications", 
        "Communications-external", "Registra comunicaciones externas", "Solicitudes Cap y Rec.", "App Movil"
    ];

    const selectedRoles = values?.role || [];
    const selectedDepartment = departmentSiglas.find(dept => dept.siglas === values?.departmentShortName);

    const toggleRole = (role) => {
        const currentRoles = selectedRoles.includes(role)
            ? selectedRoles.filter(r => r !== role)
            : [...selectedRoles, role];
        setFieldValue('role', currentRoles);
    };

    return (
        <FormikForm>
            <Grid container spacing={3}>
                
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ mb: 2 }}>Permisos del Usuario</Typography>
                    <Grid container spacing={1}>
                        {roles.map((role) => {
                            const isSelected = selectedRoles.includes(role);
                            return (
                                <Grid item xs={12} sm={6} key={role}>
                                    <FormControlLabel
                                        control={
                                            <Switch 
                                                checked={isSelected}
                                                onChange={() => toggleRole(role)}
                                                size="small"
                                            />
                                        }
                                        label={role}
                                        sx={{
                                            border: 1,
                                            borderColor: 'grey.300',
                                            borderRadius: 1,
                                            p: 1,
                                            m: 0,
                                            width: '100%',
                                            bgcolor: isSelected ? 'grey.50' : 'transparent'
                                        }}
                                    />
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ mb: 2 }}>Departamento</Typography>
                    <Autocomplete
                        options={departmentSiglas}
                        getOptionLabel={(option) => `${option.description} (${option.siglas})`}
                        value={selectedDepartment || null}
                        onChange={(_, newValue) => {
                            setFieldValue('departmentShortName', newValue?.siglas || '');
                            setFieldValue('department', newValue?.description || '');
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Departamento"
                                fullWidth
                            />
                        )}
                    />
                </Grid>

            </Grid>

            <Grid item sm={12} textAlign={"right"} mt={3}>

                <Button
                    variant="outlined"
                    onClick={() => onClose()}
                >
                    cancelar
                </Button>

                <Button sx={{ marginLeft: 2 }}
                    variant="contained"
                    type="submit"
                >
                    {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                    {isSubmitting ? 'Guardando' : 'Guardar'}
                </Button>

            </Grid>

        </FormikForm>
    );
}

export default CreateOrganizationForm;